import type { WorkspaceTool } from '@walls/store';

export function getCreateCardInitialText(event: Pick<KeyboardEvent, 'key'>) {
  if (event.key === 'Enter') {
    return '';
  }

  return event.key.length === 1 ? event.key : null;
}

export function shouldStartCreateCardFromKey({
  allowCardCreation,
  canCreate,
  editing,
  event,
  selectedTool,
}: {
  allowCardCreation: boolean;
  canCreate: boolean;
  editing: boolean;
  event: Pick<KeyboardEvent, 'altKey' | 'ctrlKey' | 'key' | 'metaKey' | 'repeat'> & {
    target: EventTarget | null;
  };
  selectedTool: WorkspaceTool;
}) {
  return Boolean(
    allowCardCreation &&
      canCreate &&
      !editing &&
      !event.repeat &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.altKey &&
      (selectedTool === 'pointer' || selectedTool === 'card') &&
      getCreateCardInitialText(event) !== null &&
      !isEditableEventTarget(event.target)
  );
}

function isEditableEventTarget(target: EventTarget | null) {
  if (!(target instanceof Element)) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();

  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    Boolean(target.closest('[contenteditable="true"]')) ||
    Boolean(target.closest('[role="dialog"]'))
  );
}
